// extracted by mini-css-extract-plugin
export var cardTitle = "_jl-1";
export var commentBubble = "_jl-e";
export var commentForm = "_jl-a";
export var commentInput = "_jl-b";
export var commentLabel = "_jl-d";
export var commentPrompt = "_jl-9";
export var csatCard = "_jl-0";
export var feedbackSection = "_jl-7";
export var starDisabled = "_jl-6";
export var starEmpty = "_jl-5";
export var starFilled = "_jl-4";
export var starWrapper = "_jl-3";
export var starsContainer = "_jl-2";
export var submittedComment = "_jl-c";
export var thankYouText = "_jl-8";